'use client';
import cn from 'classnames';
import { Settings } from 'react-slick';
import SlickCarousel from '@/components/common/SlickCarousel/SlickCarousel';

import { ProductCardData } from '@/types/Product';

import './ProductCardCarousel.style.scss';
import ProductCard from '../ProductCard/ProductCard';

import Image from 'next/image';

import ChevronDown from 'public/img/icon/chevron-down-black-carousel.svg';

type ProductCardCarouselProps = {
  className?: string;
  data: ProductCardData[];
  slickSettings?: Settings;
};

function ProductCardCarousel(props: ProductCardCarouselProps) {
  const { className = '', data, slickSettings = {} } = props;

  function Arrow(props: { className?: any; onClick?: any }) {
    const { className, onClick } = props;
    return (
      <button
        className={className}
        onClick={onClick}
      >
        <Image
          src={ChevronDown}
          height={20}
          width={11}
          alt=''
        />
        Next
      </button>
    );
  }

  return (
    <SlickCarousel
      className={cn('ProductCardCarousel', className)}
      slickSettings={{
        draggable: false,
        slidesPerRow: 3,
        centerMode: true,
        swipeToSlide: true,
        arrows: true,
        useTransform: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesPerRow: 2,
              centerMode: true,
              arrows: false
            }
          }
        ],
        nextArrow: <Arrow />,
        prevArrow: <Arrow />,
        ...slickSettings
      }}
    >
      {data.map((item) => {
        return (
          <div
            className='ProductCardCarousel-slide-wrapper'
            key={item.id}
          >
            <ProductCard
              className='ProductCardCarousel-ProductCard'
              data={item}
            />
          </div>
        );
      })}
    </SlickCarousel>
  );
}

export default ProductCardCarousel;
